/****************************************************
 * Module Name:  stoneDetailModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { AppBar, Box, Button, Container, Tooltip, Typography } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import Modal from "react-bootstrap/Modal";
import CommonSnackbar from "./commonSnackBar";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "./../../style/modalstyle.css";
import { useTheme } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab"
import SwipeableViews from "react-swipeable-views";
import PropTypes from "prop-types";
import EditIcon from '@mui/icons-material/Edit';
import HistoryIcon from '@mui/icons-material/History';
import StoneEdit from "./stoneEdit";
import StoneDetailMemoRequested from "./stoneDetailMemoRequested";
import StoneDetailMemoOut from "./stoneDetailMemoOut";
import CallMissedOutgoingIcon from '@mui/icons-material/CallMissedOutgoing';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import VideoLibraryTwoToneIcon from '@mui/icons-material/VideoLibraryTwoTone';
import StoneDetailSellPotential from "./stoneDetailSellPotential";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import StoneDetailProforma from "./stoneDetailProforma";
import StoneDetailInvoice from "./stoneDetailInvoice";
import { FaFileInvoice, FaFileInvoiceDollar } from "react-icons/fa";
import BucketDetailModal from "../mixDiamondSales/bucketDetailModal";
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";
import PacketHistoryModal from "./packetHistoryModal";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 1 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
    value: index,
  };
}

const StoneDetailModal = ({ stoneId, handleClose, show }) => {

  const [data, setData] = useState([]);
  const [detailLoader, setDetailLoader] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [successSnackbar, setSuccessSnackbar] = useState(false);
  const [updatedData, setUpdatedData] = useState([]);
  const [columnNames, setColumnNames] = React.useState([]);
  const [stoneMediaURL, setStoneMediaURL] = useState("");
  const [showBucketDetailModal, setShowBucketDetailModal] = useState(false);
  const [bucketId, setBucketId] = useState([]);
  const [kapanId, setKapanId] = useState("");
  const [showKapanDetailModal, setShowKapanDetailModal] = useState(false);
  const [packetId, setPacketId] = useState("");
  const [showPacketDetailModal, setShowPacketDetailModal] = useState(false);

  useEffect(() => {
    handleSearch(stoneId);
  }, []);

  const prepareColumns = () => {
    let columnNames = [];

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        columnNames.push(columnData);
        if (columnData.field === "status") {
          columnNames.push(
            {
              field: "username",
              headerName: "USERNAME",
              headerAlign: "center",
              align: "center",
              width: 110,
              renderCell: renderCellExpand,
              cellClassName: (params) => genericCellValueWithColorClass(params.row.boxid, params.row.prevRow.boxid)
            }
          )
        }
      }
    });
    setColumnNames(columnNames);
  }

  const handleSearch = (stoneId) => {
    setDetailLoader(true);

    let category = undefined;

    if (Constants.USER_PERMISSION.find((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.STONEDETAIL_SALES) !== undefined &&
      Constants.USER_PERMISSION.find((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.STONEDETAIL_MANUFACTURING) !== undefined &&
      Constants.USER_PERMISSION.find((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.STONEDETAIL_LAB) !== undefined)
      category = undefined; //All stone detail show
    else if (Constants.USER_PERMISSION.find((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.STONEDETAIL_SALES) !== undefined)
      category = 'sales';
    else if (Constants.USER_PERMISSION.find((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.STONEDETAIL_MANUFACTURING) !== undefined)
      category = 'manufacturing';
    else if (Constants.USER_PERMISSION.find((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.STONEDETAIL_LAB) !== undefined)
      category = 'lab';

    StoneProxy.GetSingleStoneDetail(
      stoneId,
      category,
      (responseData) => {
        prepareColumns();

        if (!responseData) {
          setDetailLoader(false);
          return;
        }

        responseData = responseData.sort((a, b) => b.id - a.id);

        let prevRow = null;
        responseData.map((iRow) => {
          if (prevRow === null) {
            prevRow = iRow
            // Considering the 1st row as the previous row, we wont be showing any color change in this
            iRow.prevRow = iRow;
          } else {
            iRow.prevRow = prevRow;
            prevRow = iRow;
          }

          return true;
        });

        if (responseData) {
          setData(responseData)
          setDetailLoader(false)
          setStoneMediaURL(responseData[0].stonemediaurl);
        } else {
          setErrorSnackbar(true)
          setDetailLoader(false)
        }
      }
    );
  };

  const handleUpdatedData = () => {
    StoneProxy.UpdateStone(

      updatedData[0],
      (responseData) => {
        if (responseData) {
          setSuccessSnackbar(true);
        } else {
          setErrorSnackbar(true);
        }
      })
  }

  const handleBucketDetailModal = (params) => {
    setBucketId(params.value);
    setShowBucketDetailModal(true)
  };

  const genericCellValueWithColorClass = (currVal, prevVal) => {
    if (!currVal || (typeof currVal === "string" && currVal.trim() === ''))
      currVal = '';
    if (!prevVal || (typeof prevVal === "string" && prevVal.trim() === ''))
      prevVal = '';

    return currVal !== prevVal ? 'blueCell' : ""
  }

  const columnsData = {
    "item-1": {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      minWidth: 50,
    },
    "9dfe5dd6-726c-465b-9f61-22fca6660b4f": {
      field: "kapanid",
      headerName: "KAPANID",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black'
          }}
          onClick={() => {
            setKapanId(params.row.kapanid);
            setShowKapanDetailModal(true);
          }}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.kapanid, params.row.prevRow.kapanid)
    },
    "8a492e00-6167-45de-b078-e572e47c8a39": {
      field: "packetid",
      headerName: "PACKETID",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: (params) => (Utility.NeedToShowPacketDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black'
          }}
          onClick={() => {
            setKapanId(params.row.kapanid)
            setPacketId(params.row.packetid)
            setShowPacketDetailModal(true)
          }}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.packetid, params.row.prevRow.packetid)
    },
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.stoneid, params.row.prevRow.stoneid)
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "54fbd914-6ce7-44a8-9354-db6125ba1992": {
      field: "tag",
      headerName: "TAG",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: (params) => (!params.value) ? "" : params.value,
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.status, params.row.prevRow.status)
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "right",
      width: 40,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
      cellClassName: (params) => genericCellValueWithColorClass(Utility.ConvertNumberWithSpecifiedDigits(params.row.size), Utility.ConvertNumberWithSpecifiedDigits(params.row.prevRow.size))
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
      cellClassName: (params) => genericCellValueWithColorClass(Utility.ConvertNumberWithSpecifiedDigits(params.row.discount), Utility.ConvertNumberWithSpecifiedDigits(params.row.prevRow.discount))
    },
    "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
      field: "rapnetprice",
      headerName: "RAP",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
      cellClassName: (params) => genericCellValueWithColorClass(Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice), Utility.ConvertNumberWithSpecifiedDigits(params.row.prevRow.rapnetprice))
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "right",
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
      cellClassName: (params) => genericCellValueWithColorClass(Utility.ConvertNumberWithSpecifiedDigits(params.row.price), Utility.ConvertNumberWithSpecifiedDigits(params.row.prevRow.price))
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "right",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.value),
      cellClassName: (params) => genericCellValueWithColorClass(Utility.ConvertNumberWithSpecifiedDigits(params.row.total), Utility.ConvertNumberWithSpecifiedDigits(params.row.prevRow.total))
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.clarity, params.row.prevRow.clarity)
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      width: 65,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.color, params.row.prevRow.color)
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 50,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.cut, params.row.prevRow.cut)
    },
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 100,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.certificateid, params.row.prevRow.certificateid)
    },
    "01e90aca-bdcb-4e8e-80ec-2d7007df8cd3": {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      minWidth: 190,
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    "ec38523c-52cc-4ea4-8de0-2838b62769c0": {
      field: "updatedat",
      headerName: "UPDATED AT",
      headerAlign: "center",
      align: "center",
      minWidth: 190,
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.flo, params.row.prevRow.flo)
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.lab, params.row.prevRow.lab)
    },
    "19ce7030-402c-495c-84ac-a29093bdb0ac": {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.locationid, params.row.prevRow.locationid)
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.pol, params.row.prevRow.pol)
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.quality, params.row.prevRow.quality)
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.shade, params.row.prevRow.shade)
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.shape, params.row.prevRow.shape)
    },
    "b9f18661-4f47-4a56-a47b-51d8baf8e071": {
      field: "labshape",
      headerName: "LAB SHAPE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.labshape, params.row.prevRow.labshape)
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      width: 40,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.cut, params.row.prevRow.cut)
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      width: 70,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.depth, params.row.prevRow.depth)
    },
    "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
      field: "height",
      headerName: "HEIGHT",
      headerAlign: "center",
      align: "center",
      width: 70,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.height, params.row.prevRow.height)
    },
    "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
      field: "width",
      headerName: "WIDTH",
      headerAlign: "center",
      align: "center",
      width: 70,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.width, params.row.prevRow.width)
    },
    "77e48fa7-d118-4ab8-865b-9b85b32a004f": {
      field: "fancycolor1",
      headerName: "F.COLOR",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.fancycolour, params.row.prevRow.fancycolour)
    },
    "ccba9873-174e-4060-963a-9893c3625bb2": {
      field: "fancycolorovertone",
      headerName: "OVERTONE",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.fancycolorovertone, params.row.prevRow.fancycolorovertone)
    },
    "c9aa6ee7-30e3-423e-a534-80bb5ef7bbaf": {
      field: "fancycolorintensity",
      headerName: "F.COL.INTENSITY",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.fancycolorintensity, params.row.prevRow.fancycolorintensity)
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.comment, params.row.prevRow.comment)
    },
    "e7210f4a-6e0a-4591-8428-e6845004ed04": {
      field: "crownheight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.crownheight, params.row.prevRow.crownheight)
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.crownangle, params.row.prevRow.crownangle)
    },
    "0f1de38d-3ae3-4209-a4d5-afe9f3018f22": {
      field: "culetsize",
      headerName: "CULET SZ",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.culetsize, params.row.prevRow.culetsize)
    },
    "e3f77521-2c57-46bc-a02b-3c884685d2be": {
      field: "culetcondition",
      headerName: "CULET",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.culetcondition, params.row.prevRow.culetcondition)
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.depthpercent, params.row.prevRow.depthpercent)
    },
    "e83c2978-9088-49f0-9dc1-bcced73025fd": {
      field: "gridlemin",
      headerName: "GIRDLEMIN",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.gridlemin, params.row.prevRow.gridlemin)
    },
    "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
      field: "intensitylongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.intensitylongtitle, params.row.prevRow.intensitylongtitle)
    },
    "06d2a589-0d42-4dde-8724-acf2448c839a": {
      field: "laserinscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.laserinscription, params.row.prevRow.laserinscription)
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.measurements, params.row.prevRow.measurements)
    },
    "dd934505-1865-48cb-878f-f5d3c18af2d5": {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      minWidth: 180,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.note, params.row.prevRow.note)
    },
    "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      minWidth: 180,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.paviliondepth, params.row.prevRow.paviliondepth)
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.tablepercent, params.row.prevRow.tablepercent)
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.location, params.row.prevRow.location)
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      minWidth: 110,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.open, params.row.prevRow.open)
    },
    "e9028170-e978-4978-a2c9-1889c1821495": {
      field: "gridlecondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      minWidth: 110,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.gridlecondition, params.row.prevRow.gridlecondition)
    },
    "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
      field: "gridlepercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      align: "center",
      minWidth: 110,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.gridlepercent, params.row.prevRow.gridlepercent)
    },
    "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
      field: "pavilionangle",
      headerName: "PV.ANGLE",
      headerAlign: "center",
      align: "center",
      minWidth: 110,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.pavilionangle, params.row.prevRow.pavilionangle)
    },
    "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      minWidth: 110,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.white, params.row.prevRow.white)
    },
    "7e356515-7cc5-4cd4-a1a4-a1b909b3b4e3": {
      field: "avgrapnetprice",
      headerName: "AVG RAP PRICE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.avgrapnetprice, params.row.prevRow.avgrapnetprice)
    },
    "a330b2b8-b9e4-40bb-bb7a-d0e83a717a74": {
      field: "avgdiscount",
      headerName: "AVG DIS",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.avgdiscount, params.row.prevRow.avgdiscount)
    },
    "1ac589a9-ff76-4b9a-9b6e-f0d7951dc0ca": {
      field: "avgprice",
      headerName: "AVG PRICE",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.avgprice, params.row.prevRow.avgprice)
    },
    "49b8f961-fe52-48ca-afbe-ceab5d7dc740": {
      field: "avgtotal",
      headerName: "AVG TOTAL",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.avgtotal, params.row.prevRow.avgtotal)
    },
    "e32fe363-07cc-4307-82d2-82ae1069b5be": {
      field: "age",
      headerName: "AGE",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => Utility.ConvertDateToAge(params.value),
    },
    "24ba0bf8-4ca1-4726-ad90-19a62c8c72e6": {
      field: "boxid",
      headerName: "BOXID",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.boxid, params.row.prevRow.boxid)
    },
    "f12c1ec3-2901-4368-ac5f-664720c5600c": {
      field: "bucketid",
      headerName: "BUCKETID",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (Utility.NeedToShowBucketDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black'
          }}
          onClick={() => handleBucketDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.bucketid, params.row.prevRow.bucketid)
    },
    "936e9971-22f8-4fa7-b176-ea7fda100632": {
      field: "consignmentno",
      headerName: "CONSIGN. No",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.consignmentno, params.row.prevRow.consignmentno)
    },
    "08a69194-0489-425a-9d6d-1933206a6e57": {
      field: "consignmentdate",
      headerName: "CONSIGN. DATE",
      headerAlign: "center",
      align: "center",
      width: 140,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.consignmentdate, params.row.prevRow.consignmentdate)
    },
    "39ebac04-5cf5-4bfa-8a03-78f0b40ec887": {
      field: "consignmentfrom",
      headerName: "CONSIGN. FROM",
      headerAlign: "center",
      align: "center",
      width: 140,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.consignmentfrom, params.row.prevRow.consignmentfrom)
    },
    "a1299782-d545-4d70-bcbc-7d576e396d64": {
      field: "length",
      headerName: "LENGTH",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.length, params.row.prevRow.length)
    },
    "dfd5488a-b600-4e75-9735-98c26f78dc84": {
      field: "strln",
      headerName: "STAR LENGTH",
      headerAlign: "center",
      align: "center",
      width: 120,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.strln, params.row.prevRow.strln)
    },
    "66dfbc62-477f-42f0-8097-56c5d8329156": {
      field: "lrhalf",
      headerName: "LR HALF",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.lrhalf, params.row.prevRow.lrhalf)
    },
    "e683145c-29dd-4d41-af1a-518ff80090d2": {
      field: "keytosymbols",
      headerName: "KEY TO SYMBOLS",
      headerAlign: "center",
      align: "center",
      width: 220,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.keytosymbols, params.row.prevRow.keytosymbols)
    },
    "16d9a51a-c6f8-463a-96df-2234267ebcc6": {
      field: "reportdate",
      headerName: "REPORT DATE",
      headerAlign: "center",
      align: "center",
      width: 220,
      cellClassName: (params) => genericCellValueWithColorClass(params.row.reportdate, params.row.prevRow.reportdate)
    },
    "a648c7fc-ebd4-4708-815e-a42cb6ad78ca": {
      field: "position",
      headerName: "POSITION",
      headerAlign: "center",
      align: "center",
      width: 90,
      type: "number",
      cellClassName: (params) => genericCellValueWithColorClass(params.row.position, params.row.prevRow.position)
    },
    "f59cf0bf-4cb1-41a9-8b7e-02871dc24a86": {
      field: "prevposition",
      headerName: "PREV POS",
      headerAlign: "center",
      align: "center",
      width: 90,
      type: "number",
      cellClassName: (params) => genericCellValueWithColorClass(params.row.prevposition, params.row.prevRow.prevposition)
    },
    "93e1268e-3c01-4bc4-b3db-48116f9adf22": {
      field: "lastpositionrevisedate",
      headerName: "LST REV POS DT",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => {
        if (params.value) {
          return Utility.ConvertUtcToLocalDate(params.value);
        } else {
          return "";
        }
      },
      cellClassName: (params) => genericCellValueWithColorClass(params.row.lastrevisepositiondate, params.row.prevRow.lastrevisepositiondate)
    },
  };

  const rows = data;
  const columns = columnNames;

  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <div>
      {successSnackbar ? (<CommonSnackbar
        show={successSnackbar}
        message="Stone Updated Successfully"
        variant={"success"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Success"}
        handleClose={() => setSuccessSnackbar(false)}
      />) : null}
      <CommonSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Failed"}
        handleClose={() => setErrorSnackbar(false)}
      />

      {showBucketDetailModal ? (
        <BucketDetailModal
          show={showBucketDetailModal}
          bucketId={bucketId}
          handleClose={() => setShowBucketDetailModal(false)}
        />
      ) : null}
      {showKapanDetailModal ? (
        <KapanHistoryModal
          show={showKapanDetailModal}
          kapanId={kapanId}
          close={() => setShowKapanDetailModal(false)}
        />
      ) : null}
      {showPacketDetailModal ? (
        <PacketHistoryModal
          show={showPacketDetailModal}
          packetId={packetId}
          kapanId={kapanId}
          close={() => setShowPacketDetailModal(false)}
        />
      ) : null}
      <Modal show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Stone Details&nbsp;
            <Tooltip title="Media Link">
              <a href={stoneMediaURL} target="_blank" rel="noopener noreferrer"><VideoLibraryTwoToneIcon sx={{ cursor: "pointer" }} /> </a>
            </Tooltip>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="inherit"
              variant={"fullWidth"}
              scrollButtons="auto"
              aria-label="full width tabs example"
              sx={{
                "& .css-1vw5i9y-MuiButtonBase-root-MuiTab-root": {
                  color: "#212121",
                  fontWeight: "bold",
                  textAlign: 'center'
                },
                "& .MuiTab-root": {
                  paddingBottom: 4
                },
                "& .Mui-selected": {
                  bgcolor: "#0277bd !important",
                  color: "#fafafa !important",
                  fontWeight: "bold !important",
                  paddingBottom: 4
                }
              }}
              TabIndicatorProps={{ style: { background: "#0277bd" } }}
            >
              {Constants.USER_PERMISSION.find(
                (iPermission) =>
                  iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL
              ) !== undefined ?
                (<Tab
                  icon={<HistoryIcon />}
                  iconPosition="start"
                  label="Stone Detail"
                  {...a11yProps(0)}
                />) : null
              }
              {Constants.USER_PERMISSION.find(
                (iPermission) =>
                  iPermission.permissionid ===
                  Constants.PERMISSIONS.STONE && iPermission.type === Constants.PERMISSION_TYPE[1]
              ) !== undefined ? (
                <Tab
                  icon={<EditIcon />}
                  iconPosition="start"
                  label="Edit Stone"
                  {...a11yProps(1)}
                />
              ) : null}
              {Constants.USER_PERMISSION.find(
                (iPermission) =>
                  iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_MEMO_REQUESTED && iPermission.type === Constants.PERMISSION_TYPE[1]
              ) !== undefined ? (
                <Tab
                  icon={<DocumentScannerIcon />}
                  iconPosition="start"
                  label="MEMO REQUESTED"
                  {...a11yProps(2)}
                />
              ) : null}
              {Constants.USER_PERMISSION.find(
                (iPermission) =>
                  iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_MEMO_OUT && iPermission.type === Constants.PERMISSION_TYPE[1]
              ) !== undefined ? (
                <Tab
                  icon={<CallMissedOutgoingIcon />}
                  iconPosition="start"
                  label="MEMO OUT"
                  {...a11yProps(3)}
                />
              ) : null}

              {Constants.USER_PERMISSION.find(
                (iPermission) =>
                  iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_SELL_POTENTIAL && iPermission.type === Constants.PERMISSION_TYPE[1]
              ) !== undefined ? (
                <Tab
                  icon={<FaMoneyBillTrendUp size={20} />}
                  iconPosition="start"
                  label="Stone Sell Potential"
                  {...a11yProps(4)}
                />
              ) : null}


              {Constants.USER_PERMISSION.find(
                (iPermission) =>
                  iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_PROFORMA && iPermission.type === Constants.PERMISSION_TYPE[1]
              ) !== undefined ? (
                <Tab
                  icon={<FaFileInvoice size={20} />}
                  iconPosition="start"
                  label="Proforma"
                  {...a11yProps(5)}
                />
              ) : null}


              {Constants.USER_PERMISSION.find(
                (iPermission) =>
                  iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_INVOICE && iPermission.type === Constants.PERMISSION_TYPE[1]
              ) !== undefined ? (
                <Tab
                  icon={<FaFileInvoiceDollar size={20} />}
                  iconPosition="start"
                  label="Invoice"
                  {...a11yProps(6)}
                />
              ) : null}
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.STONEDETAIL
            ) !== undefined ?
              <TabPanel value={value} index={0}>
                <Box
                  style={{
                    textAlign: "center",
                    fontSize: "xx-large",
                    marginTop: "0.5rem",
                    width: "100%",
                  }}
                >
                </Box>
                <Container maxWidth="xxl">
                  <Box
                    sx={{
                      backgroundColor: '#fff',
                      color: '#000',
                      width: "100%",
                      position: "relative",
                      "& .MuiTablePagination-selectLabel": {
                        marginTop: "15px",
                      },
                      "& .MuiTablePagination-displayedRows": {
                        marginTop: "15px",
                      },
                      "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                        fontWeight: Constants.defaultFontWeight,
                      },
                      "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                        color: "#1976d2",
                        padding: "4px 5px",
                        borderRadius: "4px",
                      },
                      "& .css-cc8tf1": {
                        fontWeight: Constants.defaultFontWeight,
                      },
                      "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                        color: "#1976d2",
                        padding: "5px 5px",
                        borderRadius: "4px",
                      },
                      "& .blueCell": {
                        color: "#080808",
                        backgroundColor: "#d4eff8",
                      },
                      height: "50vh",
                    }}
                  >
                    <DataGridPro
                      loading={detailLoader}
                      disableRowSelectionOnClick={true}
                      sx={{
                        '& .MuiDataGrid-columnHeader': {
                          color: '#fff',
                          backgroundColor: 'grey',
                        },
                        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                          py: "8px",
                        },
                        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                          py: "15px",
                        },
                        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                          py: "22px",
                        },
                        fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight
                      }}
                      density="compact"
                      slots={{ toolbar: GridToolbar }}
                      rows={rows}
                      columns={columns}

                      getRowId={(row) => row.id}
                      initialState={{
                        columns: {
                          columnVisibilityModel: {
                            // Hide columns id, the other columns will remain visible
                            locationid: false,
                            id: false,
                          },
                        },
                        pagination: {
                          paginationModel: Constants.pageSize,
                        },
                      }}
                      pageSizeOptions={Constants.pageSizeOptions}
                      pagination
                      slotProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                    />
                    <Box style={{ position: "absolute", top: 5, right: "270px" }}>
                      {detailLoader ? (
                        <CircularProgress size="1rem" />
                      ) : (
                        <Tooltip title="Reload List">
                          <RefreshOutlinedIcon
                            onClick={() => handleSearch(stoneId)}
                            color="primary"
                            fontSize="medium"
                            sx={{ cursor: "pointer", mr: 1 }}
                          />
                        </Tooltip>
                      )}
                    </Box>
                  </Box>

                </Container>
              </TabPanel> : <div />}
            {Constants.USER_PERMISSION.find(
              (iPermission) => {
                return iPermission.permissionid ===
                  Constants.PERMISSIONS.STONE && iPermission.type === Constants.PERMISSION_TYPE[1];
              }) !== undefined ? (
              <TabPanel value={value} index={1}>
                <StoneEdit
                  stoneId={stoneId}
                  setUpdatedData={setUpdatedData}
                />
              </TabPanel>
            ) : (
              <Box></Box>
            )}
            {Constants.USER_PERMISSION.find(
              (iPermission) => {
                return iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_MEMO_REQUESTED && iPermission.type === Constants.PERMISSION_TYPE[1];
              }) !== undefined ? (
              <TabPanel value={value} index={2}>
                <StoneDetailMemoRequested
                  stoneid={stoneId}
                />
              </TabPanel>
            ) : (
              <Box></Box>
            )}
            {Constants.USER_PERMISSION.find(
              (iPermission) => {
                return iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_MEMO_OUT && iPermission.type === Constants.PERMISSION_TYPE[1];
              }) !== undefined ? (
              <TabPanel value={value} index={3}>
                <StoneDetailMemoOut
                  stoneid={stoneId}
                />
              </TabPanel>
            ) : (
              <Box></Box>
            )}
            {Constants.USER_PERMISSION.find(
              (iPermission) => {
                return iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_SELL_POTENTIAL && iPermission.type === Constants.PERMISSION_TYPE[1];
              }) !== undefined ? (
              <TabPanel value={value} index={4}>
                <StoneDetailSellPotential
                  stoneid={stoneId}
                />
              </TabPanel>
            ) : (
              <Box></Box>
            )}
            {Constants.USER_PERMISSION.find(
              (iPermission) => {
                return iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_PROFORMA && iPermission.type === Constants.PERMISSION_TYPE[1];
              }) !== undefined ? (
              <TabPanel value={value} index={5}>
                <StoneDetailProforma
                  stoneid={stoneId}
                />
              </TabPanel>
            ) : (
              <Box></Box>
            )}
            {Constants.USER_PERMISSION.find(
              (iPermission) => {
                return iPermission.permissionid ===
                  Constants.PERMISSIONS.STONEDETAIL_INVOICE && iPermission.type === Constants.PERMISSION_TYPE[1];
              }) !== undefined ? (
              <TabPanel value={value} index={6}>
                <StoneDetailInvoice
                  stoneid={stoneId}
                />
              </TabPanel>
            ) : (
              <Box></Box>
            )}
          </SwipeableViews>
        </Modal.Body>
        <Modal.Footer>
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.STONE && iPermission.type === Constants.PERMISSION_TYPE[1]
          ) !== undefined && value === 1 ? (
            <Button variant="contained" color="success" onClick={handleUpdatedData} style={{ marginRight: '20px' }} disabled={updatedData.length === 0}>
              Update
            </Button>
          ) : null}
          <Button variant="contained" color="error" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StoneDetailModal;
